import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-package-detail"
  }, [_vm.renderNewPackage ? _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("套餐详情")]), _c('div', {
    staticClass: "package-content",
    class: {
      'no-viewmore': !_vm.showMoreVisible
    }
  }, [_vm._l(_vm.particalList, function (product, index) {
    return [_c('div', {
      key: index,
      staticClass: "product",
      class: {
        'show-viewmore': _vm.showMoreVisible
      }
    }, [_c('div', {
      staticClass: "product-title"
    }, [_c('span', {
      staticClass: "title-text",
      class: {
        maxwidth: product.totalPrice > 0
      }
    }, [_vm._v(_vm._s(product.title))]), product.totalPrice > 0 ? _c('span', {
      staticClass: "total-price"
    }, [_c('i', [_vm._v("门市价")]), _c('span', {
      staticClass: "yuan"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(product.totalPrice))])]) : _vm._e()]), product.totalPrice !== -1 ? _vm._l(product.includes, function (sub, j) {
      return _c('div', {
        key: j,
        staticClass: "sub-detail"
      }, [_c('span', {
        staticClass: "sub-title",
        class: {
          'maxwidth-limit': sub.price > 0
        }
      }, [_vm._v(_vm._s(sub.content))]), sub.stock ? _c('span', {
        staticClass: "count"
      }, [_vm._v(_vm._s("(".concat(sub.stock, ")")))]) : _vm._e(), _c('span', {
        staticClass: "sub-price"
      }, [sub.price ? _c('i', [_vm._v("￥")]) : _vm._e(), _vm._v(_vm._s(sub.price))])]);
    }) : _vm._e()], 2)];
  })], 2), _vm.showMoreVisible ? _c('div', {
    staticClass: "btn-viewmore"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.showMoreList();
      }
    }
  }, [_vm._v("查看全部")]), _c('ycf-image', {
    staticClass: "arrow-down",
    attrs: {
      "src": require("../../assets/img/arrow-down@2x.png")
    }
  })], 1) : _vm._e()]) : _vm.renderOldPackage ? _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("套餐详情")]), _c('div', {
    staticClass: "old-package-content",
    domProps: {
      "innerHTML": _vm._s(_vm.oldPackageIncludes)
    }
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };